import { motion } from "framer-motion";
import { Bot, Flame, Skull, Trophy } from "lucide-react";
import { useLang } from "@/lib/i18n";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.18, delayChildren: 0.2 } },
};
const bubble = {
  hidden: { opacity: 0, y: 18, scale: 0.98 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export default function Resenha() {
  const { t } = useLang();
  const r = t.resenha;
  return (
    <section id="resenha" className="py-24 md:py-32 border-b border-white/10 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        {/* Left copy */}
        <div>
          <p className="font-mono-pw uppercase text-xs tracking-[0.3em] text-[#E6FF00] mb-5">{r.overline}</p>
          <h2 className="font-anton uppercase leading-[0.88] text-5xl md:text-7xl mb-7">
            {r.headA} <br /> <span className="pw-outline-text">{r.headB}</span>
          </h2>
          <p className="font-body text-white/70 leading-relaxed max-w-md mb-8">
            {r.para}
          </p>
          <ul className="space-y-4">
            {r.bullets.map((b) => (
              <li key={b} className="flex gap-3 font-body text-sm text-white/80">
                <span className="text-[#E6FF00] font-mono-pw">›</span>
                {b}
              </li>
            ))}
          </ul>
        </div>

        {/* Right: chat mockup */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-120px" }}
          data-testid="resenha-chat"
          className="relative border border-white/10 bg-[#111111] p-5 md:p-6"
        >
          <div className="flex items-center gap-3 border-b border-white/10 pb-4 mb-5">
            <div className="w-9 h-9 bg-[#E6FF00] flex items-center justify-center">
              <Bot size={20} className="text-black" />
            </div>
            <div>
              <div className="font-mono-pw uppercase text-xs tracking-[0.15em] text-white">Bot Judge</div>
              <div className="font-mono-pw text-[10px] text-[#39FF14]">● Futebol de Quarta · {r.live}</div>
            </div>
          </div>

          <div className="space-y-4">
            {/* Pin result card */}
            <motion.div variants={bubble} className="border border-[#E6FF00]/40 bg-[#0A0A0A] p-4">
              <div className="font-mono-pw uppercase text-[10px] tracking-[0.2em] text-white/40 mb-3">{r.pinLabel}</div>
              <div className="flex items-center justify-between">
                <span className="font-anton text-xl">LÉO</span>
                <span className="font-anton text-3xl text-[#E6FF00]">7 <span className="text-white/30">×</span> 4</span>
                <span className="font-anton text-xl text-white/60">MARI</span>
              </div>
            </motion.div>

            <motion.div variants={bubble} className="bg-[#0A0A0A] border border-white/10 p-4 max-w-[85%]">
              <p className="font-body text-sm text-white">{r.m1}</p>
              <div className="flex gap-2 mt-3">
                <span className="flex items-center gap-1 border border-white/10 px-2 py-0.5 text-xs"><Flame size={12} className="text-[#E6FF00]" /> 4</span>
                <span className="flex items-center gap-1 border border-white/10 px-2 py-0.5 text-xs"><Skull size={12} className="text-white/70" /> 2</span>
              </div>
            </motion.div>

            <motion.div variants={bubble} className="bg-[#0A0A0A] border border-white/10 p-4 max-w-[90%]">
              <p className="font-body text-sm text-white">
                {r.m2pre}<span className="text-[#E6FF00] font-semibold">{r.m2strong}</span>{r.m2post}
              </p>
            </motion.div>

            <motion.div variants={bubble} className="bg-[#0A0A0A] border border-white/10 p-4 max-w-[85%]">
              <p className="font-body text-sm text-white/90">
                {r.m3}
              </p>
              <div className="flex gap-2 mt-3">
                <span className="flex items-center gap-1 border border-white/10 px-2 py-0.5 text-xs"><Trophy size={12} className="text-[#E6FF00]" /> 1</span>
                <span className="border border-white/10 px-2 py-0.5 text-xs">😂 6</span>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
